import { createGlobalStyle } from 'styled-components';
import colors from '../../../styles/colors';

export const TiptapGlobalStyles = createGlobalStyle`
  // Composer Container
  .composer-outer-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    position: relative;
    box-sizing: border-box;
  }

  /* Single Line State: Text on left, action icons on right */
  .composer-inner-body.is-single-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 42px;
    padding: 0 8px;
    box-sizing: border-box;
    width: 100%;
  }

  .composer-inner-body.is-single-row .editor-area-wrapper {
    flex: 1;
    min-width: 0;
  }

  .composer-inner-body.is-single-row .editor-area-wrapper .ProseMirror {
    padding: 8px 8px;
    line-height: 20px;
    min-height: 20px;
    max-height: 38px;
    overflow: hidden;
  }

  .composer-inner-body.is-single-row .composer-actions-wrapper {
    margin-left: auto;
    padding-right: 2px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  /* Multi-Line State (Matching Teams / Desktop Composer Layout) */
  .composer-inner-body.is-multi-col {
    display: flex;
    flex-direction: column;
    padding: 8px 12px 6px 12px;
    box-sizing: border-box;
    width: 100%;
  }

  .composer-inner-body.is-multi-col .editor-area-wrapper {
    width: 100%;
  }

  .composer-inner-body.is-multi-col .editor-area-wrapper .ProseMirror {
    width: 100%;
    padding: 2px 0;
    min-height: 52px;
    max-height: 180px;
    overflow-y: auto;
    line-height: 20px;
  }

  .composer-inner-body.is-multi-col .composer-actions-wrapper {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding-top: 6px;
    box-sizing: border-box;
  }

  /* Common ProseMirror styles */
  .editor-area-wrapper .ProseMirror {
    width: 100%;
    outline: none;
    font-size: 14px;
    color: #2c3e50;
    box-sizing: border-box;
    cursor: text;
    white-space: pre-wrap !important;
    word-break: break-word !important;
  }

  .editor-area-wrapper .ProseMirror p {
    margin: 0;
    line-height: 20px;
  }

  .editor-area-wrapper .ProseMirror p.is-editor-empty:first-child::before {
    color: #a8abb2;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  }

  /* Typography styles */
  .editor-area-wrapper .ProseMirror strong,
  .editor-area-wrapper .ProseMirror b {
    font-weight: 700 !important;
  }

  .editor-area-wrapper .ProseMirror em,
  .editor-area-wrapper .ProseMirror i {
    font-style: italic !important;
  }

  .editor-area-wrapper .ProseMirror u {
    text-decoration: underline !important;
  }

  .editor-area-wrapper .ProseMirror s,
  .editor-area-wrapper .ProseMirror strike {
    text-decoration: line-through !important;
  }

  .editor-area-wrapper .ProseMirror ul {
    list-style-type: disc !important;
    padding-left: 24px !important;
    margin: 4px 0 !important;
  }

  .editor-area-wrapper .ProseMirror ol {
    list-style-type: decimal !important;
    padding-left: 24px !important;
    margin: 4px 0 !important;
  }

  /* Action Icons Row */
  .composer-bottom-row {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .action-icon-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2d3748;
    transition: color 0.15s ease, background 0.15s ease;
  }

  .action-icon-btn svg {
    font-size: 22px !important;
  }

  .action-icon-btn:hover {
    background: #f0f2f5;
    color: ${colors.brand_600};
  }

  .action-icon-btn.active-format {
    color: ${colors.brand_600} !important;
  }

  .action-divider {
    width: 1px;
    height: 18px;
    background: #dcdfe6;
    margin: 0 4px;
  }

  /* Top Formatting Toolbar */
  .tiptap-toolbar {
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 4px 10px;
    background: #f8f9fa;
    border-bottom: 1px solid #ebeef5;
    border-radius: 7px 7px 0 0;
    width: 100%;
    box-sizing: border-box;
  }
  
  .toolbar-close-btn {
    margin-left: auto;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #909399;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }

  .toolbar-close-btn:hover {
    background: #f2f6fc;
    color: #303133;
  }

  /* Mention Dropdown (Rendered in document.body by Tippy) */
  .tippy-box {
    background-color: transparent !important;
    box-shadow: none !important;
    border: none !important;
  }

  .tippy-content {
    padding: 0 !important;
  }

  .tippy-arrow {
    display: none !important;
  }

  .mention-dropdown {
    background: #ffffff !important;
    border: 1px solid #dcdcdc !important;
    border-radius: 6px !important;
    padding: 5px !important;
    min-width: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1) !important;
  }

  .mention-item {
    padding: 6px 10px !important;
    cursor: pointer !important;
    color: #2c3e50 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
    transition: background 0.15s ease !important;
  }

  .mention-item:hover {
    background: #f2f4f8 !important;
    color: ${colors.brand_600} !important;
  }

  .mention-item-empty {
    padding: 6px 10px;
    color: #909399;
    font-size: 13px;
  }

  .mention {
    font-weight: 700 !important;
    padding: 2px 4px !important;
    border-radius: 4px !important;
  }

  /* Link Preview Card */
  .link-preview-node-wrapper {
    position: relative;
    display: block;
    margin: 6px 0;
    max-width: 440px;
    width: 100%;
  }

  .closeIcon {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    color: #606266;
    transition: background 0.15s ease, color 0.15s ease;
  }

  .closeIcon:hover {
    background: #f56c6c;
    color: #ffffff;
  }

  .link-preview-card {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    border: 1px solid #e1dfdd;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    min-height: 80px;
  }

  .link-preview-image {
    width: 90px;
    height: 90px;
    object-fit: cover;
    flex-shrink: 0;
    background: #f5f7fa;
  }

  .link-preview-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 28px 8px 12px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .link-preview-title {
    font-size: 13px;
    font-weight: 600;
    color: #1976d2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
  }

  .link-preview-description {
    font-size: 12px;
    color: #605e5c;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-top: 2px;
    line-height: 1.3;
  }

  .link-preview-url {
    font-size: 11px;
    color: #1976d2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 4px;
  }

  /* Inline Link Preview Loading Spinner */
  .inline-link-preview-loader {
    display: inline-flex;
    align-items: center;
    margin: 0 6px;
    vertical-align: middle;
  }

  .inline-link-preview-spinner {
    width: 13px;
    height: 13px;
    border: 2px solid #b8eef7;
    border-top-color: ${colors.brand_600};
    border-radius: 999px;
    animation: inline-link-preview-spin 0.8s linear infinite;
  }

  @keyframes inline-link-preview-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
